export const PDF = 'pdf';
export const PNG = 'png';
export const CSV = 'csv';
export const XLS = 'xls';
export const GIF = 'gif';
